/* 雲端禮贈品：產品頁加強（詢價按鈕放進商品表單、訂製流程步驟切換） */
(function () {
  /* 把「加入詢價單」移進商品表單：詢價 App 會從表單讀取目前選擇的規格 */
  function placeQuote() {
    var wrap = document.querySelector('[data-cg-pdp-quote]');
    if (!wrap || wrap.dataset.cgPlaced) return;
    var form = document.querySelector('product-information form[data-type="add-to-cart-form"]') ||
               document.querySelector('product-information form[action*="/cart/add"]:not(.installment)');
    if (!form) return;
    var submit = form.querySelector('.product-form__controls-group--submit');
    if (submit) form.insertBefore(wrap, submit); else form.appendChild(wrap);
    wrap.dataset.cgPlaced = '1';
  }

  /* 訂製流程：點步驟切換說明，也可用左右箭頭 */
  function initSteps(root) {
    if (root.dataset.cgReady) return;
    root.dataset.cgReady = '1';
    var tabs = root.querySelectorAll('[data-cg-step-tab]');
    var panels = root.querySelectorAll('[data-cg-step-panel]');
    var prev = root.querySelector('[data-cg-step-prev]');
    var next = root.querySelector('[data-cg-step-next]');
    var i = 0;
    function go(n) {
      i = Math.max(0, Math.min(tabs.length - 1, n));
      tabs.forEach(function (t, k) {
        t.classList.toggle('is-active', k === i);
        t.classList.toggle('is-done', k < i);
        t.setAttribute('aria-selected', k === i ? 'true' : 'false');
        t.tabIndex = k === i ? 0 : -1;
      });
      panels.forEach(function (p, k) { p.hidden = k !== i; });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === tabs.length - 1;
    }
    tabs.forEach(function (t, k) {
      t.addEventListener('click', function () { go(k); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { go(i + 1); tabs[i].focus(); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { go(i - 1); tabs[i].focus(); e.preventDefault(); }
      });
    });
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    go(0);
  }

  /* 商品介紹第一段做成引言樣式 */
  function markLead() {
    var d = document.querySelector('.product-single__description');
    if (!d || d.querySelector('.cg-pdp__lead')) return;
    var ps = d.querySelectorAll(':scope > p');
    for (var k = 0; k < ps.length; k++) {
      if (ps[k].textContent.trim()) { ps[k].classList.add('cg-pdp__lead'); break; }
    }
  }

  /* 取消主題「捲動時資訊欄變成懸浮深色面板」：移除相關 class，資訊欄跟著頁面捲動 */
  var MODAL = ['product__info-container--modal', 'product__info-container--modal--out', 'background-modal'];
  function noFloat() {
    var c = document.querySelector('product-information .product__info-container');
    if (!c || c.dataset.cgNoFloat) return;
    c.dataset.cgNoFloat = '1';
    var strip = function () {
      MODAL.forEach(function (k) { if (c.classList.contains(k)) c.classList.remove(k); });
    };
    strip();
    if (window.MutationObserver) new MutationObserver(strip).observe(c, { attributes: true, attributeFilter: ['class'] });
  }

  /* 商品描述的「商品規格」標題＋表格移到右側資訊欄（規格只出現一次） */
  function moveSpecs() {
    var slot = document.querySelector('[data-cg-specs-slot]');
    var d = document.querySelector('.product-single__description');
    if (!slot || !d || slot.dataset.cgDone) return;
    var hs = d.querySelectorAll(':scope > h2');
    for (var k = 0; k < hs.length; k++) {
      if (hs[k].textContent.indexOf('規格') > -1) {
        var t = hs[k].nextElementSibling;
        if (t && t.tagName === 'TABLE') {
          slot.appendChild(hs[k]);
          slot.appendChild(t);
          slot.hidden = false;
          slot.dataset.cgDone = '1';
        }
        break;
      }
    }
    if (slot.dataset.cgDone) return;
    /* 舊格式：「材質：…」「尺寸：…」條列清單 → 移到同一位置，排成規格表 */
    var re = /^\s*([^：:\n]{1,8})[：:]\s*([\s\S]*)$/;
    var uls = d.querySelectorAll(':scope > ul');
    for (var u = 0; u < uls.length; u++) {
      var lis = Array.prototype.filter.call(uls[u].children, function (el) { return el.tagName === 'LI'; });
      var hits = lis.filter(function (li) { return re.test(li.textContent); });
      if (hits.length < 2) continue;
      var list = uls[u];
      list.classList.add('cg-pdp__speclist');
      lis.forEach(function (li) {
        var m = li.textContent.match(re);
        if (!m || !m[2].trim()) { li.className = 'cg-spec cg-spec--note'; return; }
        var key = m[1].trim();
        li.className = 'cg-spec' + (key === '產品' ? ' cg-spec--name' : '');
        li.textContent = '';
        var k = document.createElement('span'); k.className = 'cg-spec__k'; k.textContent = key;
        var colon = document.createElement('span'); colon.className = 'visually-hidden'; colon.textContent = '：';
        var v = document.createElement('span'); v.className = 'cg-spec__v'; v.textContent = m[2].trim();
        li.appendChild(k); li.appendChild(colon); li.appendChild(v);
      });
      var title = document.createElement('div');
      title.className = 'cg-pdp__specs-title';
      title.textContent = '商品規格';
      slot.appendChild(title);
      slot.appendChild(list);
      slot.hidden = false;
      slot.dataset.cgDone = '1';
      break;
    }
  }

  /* 商品描述分區塊：每個 H2 一區；常見問題的 H3＋答案包成卡片 */
  function groupDesc() {
    var d = document.querySelector('.product-single__description');
    if (!d || d.dataset.cgGrouped) return;
    d.dataset.cgGrouped = '1';
    var nodes = Array.prototype.slice.call(d.childNodes);
    var block = null;
    nodes.forEach(function (n) {
      if (n.nodeType === 1 && n.tagName === 'H2') {
        block = document.createElement('div');
        block.className = 'cg-desc__block';
        d.appendChild(block);
      }
      if (block) block.appendChild(n);
    });
    d.querySelectorAll('.cg-desc__block').forEach(function (b) {
      var h3s = b.querySelectorAll(':scope > h3');
      if (!h3s.length) return;
      b.classList.add('cg-desc__block--qa');
      var grid = document.createElement('div');
      grid.className = 'cg-desc__qa-grid';
      h3s[0].parentNode.insertBefore(grid, h3s[0]);
      h3s.forEach(function (h) {
        var item = document.createElement('div');
        item.className = 'cg-qa';
        var next = h.nextElementSibling;
        item.appendChild(h);
        while (next && next.tagName !== 'H3' && next.tagName !== 'H2') {
          var after = next.nextElementSibling;
          item.appendChild(next);
          next = after;
        }
        grid.appendChild(item);
      });
    });
  }

  /* 商品介紹第一段移到右側資訊欄（金額上方） */
  function moveLead() {
    var lead = document.querySelector('.product-single__description .cg-pdp__lead');
    var info = document.querySelector('product-information .product__info-wrapper');
    var price = info && info.querySelector('.product__price');
    if (!lead || !price) return;
    lead.classList.add('cg-pdp__lead--side');
    price.parentNode.insertBefore(lead, price);
  }

  /* 常見問題移到「印刷方式」區塊之後（與訂製流程對調位置；標題與內容不變） */
  function moveFaq() {
    var qa = document.querySelector('.product-single__description .cg-desc__block--qa');
    var craft = document.querySelector('[id$="__cg_pdp_craft"]');
    if (!qa || !craft || document.querySelector('.cg-pdp-faq')) return;
    var sec = document.createElement('div');
    sec.className = 'cg cg-pdp-faq';
    var wrap = document.createElement('div');
    wrap.className = 'cg-wrap';
    var eb = document.createElement('div');
    eb.className = 'cg-eyebrow';
    eb.textContent = 'FAQ';
    wrap.appendChild(eb);
    var h2 = qa.querySelector(':scope > h2');
    if (h2) {
      h2.classList.add('cg-h2');
      var rule = document.createElement('span');
      rule.className = 'cg-rule';
      rule.setAttribute('aria-hidden', 'true');
      h2.parentNode.insertBefore(rule, h2.nextSibling);
    }
    wrap.appendChild(qa);
    sec.appendChild(wrap);
    craft.parentNode.insertBefore(sec, craft.nextSibling);
  }

  function init(scope) {
    noFloat();
    placeQuote();
    moveSpecs();
    markLead();
    groupDesc();
    moveLead();
    moveFaq();
    (scope || document).querySelectorAll('[data-cg-steps]').forEach(initSteps);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
